module.exports = __webpack_public_path__ + "static/media/1POLICY9.d8c10354.jpg";